"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputProps = inputProps;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function inputProps(valueType) {
  return {
    id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    value: valueType,
    defaultValue: valueType,
    onChange: _propTypes["default"].func,
    isDisabled: _propTypes["default"].bool,
    isRequired: _propTypes["default"].bool
  };
}